import './policy.css'

const GetHelp = ()=>{
    return(<div className="page-root"><img src='/arrow-left-solid.svg' alt="arrow"/></div>)
}

export default GetHelp;